var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"counter"},[_vm._v("\n  "+_vm._s(_vm.counter)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }